var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSocialFb = function SvgSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3043_31347)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 14.95 3.6 19.05 8.35 19.9L8.40915 19.8516C8.4061 19.8511 8.40304 19.8505 8.39999 19.8499V12.7999H5.89999V9.99994H8.39999V7.79994C8.39999 5.29994 9.99999 3.89994 12.3 3.89994C13 3.89994 13.8 3.99994 14.5 4.09994V6.64994H13.2C12 6.64994 11.7 7.24994 11.7 8.04994V9.99994H14.35L13.9 12.7999H11.7V19.8499C11.6695 19.8555 11.639 19.8609 11.6086 19.8661L11.65 19.9C16.4 19.05 20 14.95 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3043_31347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSocialFb);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/social-fb.28272af4cd2130dc14f117b81ec53fec.svg";